import { Line } from 'components/common/types/Deal.types';
import { DirectSalesLine } from 'components/common/types/DirectSalesCampaign.types';

export const mergeCurrentLineToAllLines = (lines: DirectSalesLine[], currentLine: Line): DirectSalesLine[] =>
  lines.map((line) => (line.lineId === currentLine.lineId ? (currentLine as DirectSalesLine) : line));
